import axios from '../axios-marketplace';

const getList = (params) => axios.get('/fornecedor/alertas', {
  params,
});

export default {
  getList,
};
